import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseLayoutComponent } from './layout/base-layout/base-layout.component';
import { ProcessFolioComponent } from './shared/components/process-folio/process-folio.component';
const routes: Routes = [
	{
		path: '',
		component: BaseLayoutComponent,
		children: [
			{
				path: 'credit',
				loadChildren: () =>
					import('./content/credit/credit.module').then(m => m.CreditModule),
			},
			{
				path: 'account',
				loadChildren: () =>
					import('./content/accounts/accounts.module').then(
						m => m.AccountsModule
					),
			},
			{
				path: 'sites',
				loadChildren: () =>
					import('./content/sites/sites.module').then(m => m.SitesModule),
			},
			{
				path: '',
				redirectTo: '/p/acticash',
				pathMatch: 'full',
			},
			{
				path: 'p',
				loadChildren: () =>
					import('./content/sites/sites.module').then(m => m.SitesModule),
			},
			{
				path: 'p/:id',
				component: ProcessFolioComponent,
			},
		],
	},
	{
		path: '**',
		redirectTo: '/',
		pathMatch: 'full',
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
